/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetKeysByReadKeyParams,
  PostKeysResponse,
  GetKeysByReadKeyResponse,
} from '../types';

export class Keys extends Controller {
  async postKeys<T extends PostKeysResponse, D, C extends null>(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/keys',
      body,
      axiosConfig
    );
  }

  async getKeysByReadKey<T extends GetKeysByReadKeyResponse, D, C>(
    { readKey }: GetKeysByReadKeyParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/keys/${readKey}`,
      axiosConfig
    );
  }
}
